import { useIsMobile } from "../hooks/useIsMobile";

export function withMobileView(DesktopComponent, MobileComponent) {
  return function AdaptiveView(props) {
    const isMobile = useIsMobile();
    return isMobile ? (
      <MobileComponent {...props} />
    ) : (
      <DesktopComponent {...props} />
    );
  };
}
